import React, { useEffect, useRef, useState } from 'react';
import '../FlashMessage/Flash.css';
import './Message.css';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import Bus from '../../../Utils/Bus';

function Message() {
  const [visibility, setVisibility] = useState(false);
  const [message, setMessage] = useState('');
  const [type, setType] = useState('');

  const toast = useRef(null);

  useEffect(() => {
    Bus.addListener('show', ({ message, type }) => {
      setVisibility(true);
      setMessage(message);
      setType(type);
    });
    Bus.addListener('hide', () => {
      setVisibility(false);
    });
  }, []);

  // Show toast when visibility changes
  useEffect(() => {
    if (visibility && toast.current) {
      if (type === 'loading') {
        // For loading messages, use a custom message
        toast.current.show({
          severity: 'info',
          sticky: true,
          content: (
            <div className='message-loading-container'>
              <ProgressSpinner className='message-spinner' />
              <div className='message-text'>{message}</div>
            </div>
          ),
        });
      } else {
        // For regular messages
        toast.current.show({
          severity: type,
          summary:
            type === 'error'
              ? 'Error'
              : type === 'success'
              ? 'Success'
              : 'Information',
          detail: message,
          sticky: true,
          closable: true,
          onHide: () => setVisibility(false),
        });
      }
    } else if (!visibility && toast.current) {
      toast.current.clear();
    }
  }, [visibility, type, message]);

  return <Toast ref={toast} position='top-center' className='message-toast' />;
}
export default Message;
